import { Link } from "react-router-dom";

interface NewsSubmissionCTAProps {
  variant?: "light" | "dark" | "blue";
  title?: string;
  description?: string;
}

export default function NewsSubmissionCTA({
  variant = "blue",
  title = "¿Tienes una noticia?",
  description = "¿Eres parte del sector turístico, aeronáutico o hotelero? Comparte tu noticia con miles de lectores.",
}: NewsSubmissionCTAProps) {
  const bgClasses = {
    light: "bg-white border border-slate-100",
    dark: "bg-[#0B1F3A]",
    blue: "bg-blue-600",
  };

  const textClasses = {
    light: "text-[#0B1F3A]",
    dark: "text-white",
    blue: "text-white",
  };

  const subClasses = {
    light: "text-slate-500",
    dark: "text-blue-200/70",
    blue: "text-blue-100",
  };

  const btnClasses = {
    light: "bg-[#0B1F3A] hover:bg-slate-800 text-white",
    dark: "bg-white hover:bg-blue-50 text-[#0B1F3A]",
    blue: "bg-white hover:bg-blue-50 text-blue-600",
  };

  return (
    <div className={`${bgClasses[variant]} rounded-xl p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4`}>
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${variant === "light" ? "bg-emerald-50" : "bg-white/15"}`}>
          <i className={`ri-file-add-line ${variant === "light" ? "text-emerald-600" : "text-white"} text-lg`} />
        </div>
        <div>
          <p className={`${textClasses[variant]} font-bold text-sm mb-0.5`} style={{ fontFamily: "'Sora', sans-serif" }}>
            {title}
          </p>
          <p className={`${subClasses[variant]} text-xs leading-relaxed max-w-md`} style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            {description}
          </p>
        </div>
      </div>
      <Link
        to="/contacto"
        className={`inline-flex items-center gap-2 px-5 py-2.5 ${btnClasses[variant]} text-sm font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap flex-shrink-0`}
        style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
      >
        <i className="ri-send-plane-line" />
        Enviar Noticia
      </Link>
    </div>
  );
}